<template>
  <div id="content" class="d-flex flex-column h-100 mh-100">
    <slot name="secondary-nav"></slot>
    <slot name="main-canvas-ad"></slot>
    <slot name="main-canvas"></slot>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'

export default {
  name: "MainCanvas",
  props: {},
  components: {},
  mixins: [
    store,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>
#content {
  background: #F5F5F5;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;

  .dark-mode & {
    background:#1E1E1E;;
    color:white;
  }
}

.mh-100 {
  min-height: 100%;
}

.secondary-nav {
  display: flex;
  justify-content: space-between;
  height: 50px;
  align-items: center;
  background: white;
  border-bottom: 1px solid #CBCBCB;
  padding: 0 20px;
  min-height: 50px;

  .dark-mode & {
    background:#272727;
    border-bottom: 1px solid #595959;
    color: white;
  }
}
</style>
